import { render, staticRenderFns } from "./DataExportChip.vue?vue&type=template&id=116643ac&scoped=true"
import script from "./DataExportChip.vue?vue&type=script&lang=js"
export * from "./DataExportChip.vue?vue&type=script&lang=js"
import style0 from "./DataExportChip.vue?vue&type=style&index=0&id=116643ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116643ac",
  null
  
)

export default component.exports